import React, { useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Alert from 'react-s-alert';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

import GeneralNavbar from './GeneralNavbar';

const BookSessionQuestionaire = () => {

    const { theme, fontFamily, colors } = useContext(ThemeContext);

    const [clicked, setClicked] = useState({ to: "/user/signin" });
    const [bookedFor, setBookedFor] = useState("self");

    // useEffect(() => console.log('bookedFor', bookedFor), [bookedFor])

    const forMySelf = () => {
        setClicked({ to: "/user/signin" });
        setBookedFor('self');
    }

    const forSomeOneElse = () => {
        setClicked({ to: "/umangwellnessgift" });
        setBookedFor('other');
    }

    const gotoGVPage = () => {
        try {
            if (window.confirm("By clicking on OK you will be redirected to RazorPay Payment page to buy GiftVoucher")) {
                window.location.href = "https://rzp.io/l/jkStIE8";
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
        }
    }

    return (
        <div style={{ fontFamily: fontFamily.primary }}>
            <GeneralNavbar />
            <div className='m-5' style={{ textAlign: "center" }}>
                <h3 style={theme.newParagraphHeading}>Help us get you the service you want</h3>
                <p className='m-2' style={theme.headingRegular}>Please fill out this short questionnaire to help us navigate you to service you want.</p>
            </div>
            <div className='d-flex align-items-center justify-content-center mx-auto'>
                <div style={{ width: "450px", height: "450px", borderRadius: "10px", boxShadow: " 0px 2px 10px rgba(0, 0, 0, 0.25)" }}>
                    <h5 className='mt-4 ml-4'>I am Booking Session for - </h5>
                    <div className='d-flex flex-column align-items-center'>
                        <button className='mt-5' style={bookedFor === 'self' ? { border: "4px solid #70B646", height: "100px", width: "350px", background: "#fff", borderRadius: "20px" } : { border: "2px solid #000", height: "100px", width: "350px", background: "#fff", borderRadius: "20px" }} onClick={() => { forMySelf() }}>Myself</button>
                        <button className='mt-3' style={bookedFor === 'other' ? { border: "4px solid #70B646", height: "100px", width: "350px", background: "#fff", borderRadius: "20px" } : { border: "2px solid #000", height: "100px", width: "350px", background: "#fff", borderRadius: "20px" }} onClick={() => { forSomeOneElse() }}>Someone else</button>
                        <Link to={clicked.to}>
                            <button className='mt-3' style={theme.newButtonRounded} onClick={clicked.to === '/umangwellnessgift' ? gotoGVPage : ""} >Book</button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default BookSessionQuestionaire;